import { isValidChainId, type ValidChainId, } from "@bracket/addressbook";
import { getChainId as getWagmiChainId, } from "wagmi/actions";
import { wagmiConfig, } from "@config";

/** wagmi v1 and v2 differ in a way that would produce bugs in the migration, so we  */
export const getChainId = ( ): ValidChainId => {
	const chainId = getWagmiChainId(wagmiConfig);

	if( chainId && isValidChainId( chainId ) ) {
		return chainId;
	}
	throw new Error(`@bracket/stake-app/helpers::getChainId failed to gain a valid chain id`);
}
